import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';

import InputField from 'src/legacy/components/InputField';
import ImageEditor from 'src/legacy/components/ImageEditor/index.jsx';
import Button from 'src/components/button';
import userRoleService from "src/services/userRoles.service"
import isEqual from 'is-equal';
import cx from 'classnames';
import lodash from 'lodash';
import styles from './styles.module.scss';
import InfiniteScroll from 'react-infinite-scroller';
import { localizedStrings } from 'src/localization/index.jsx';
import DOMPurify from "dompurify";
import _ from 'lodash';

class ContactForm extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleUploadContactImage = this._handleUploadContactImage.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.onUploadCancel = this.onUploadCancel.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.loadMoreOrganizations = this.loadMoreOrganizations.bind(this);

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedContacts = this.localizedCommons.sliders.contacts;
    this.localizedUpdateContact = this.localizedContacts.update_contact;

  }

  getInitialState() {
    return {
      editing: false,
      firstName: '',
      lastName: '',
      email: '',
      title: '',
      company: '',
      workPhone: '',
      mobilePhone: '',
      facebook: '',
      linkedin: '',
      twitter: '',
      instagram: '',
      errors: {},
      tempIcon: null,
      icon: null,
      file: null,
      modifiedDate: '',
      errorMessage: null,
      query: "",
      organizations: []
    }
  }

  _handleCreateClick() {
    const errors = this.validateForm();
    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors
      });

      return;
    }

    let contact = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      title: this.state.title,
      company: this.state.company,
      workPhone: this.state.workPhone,
      mobilePhone: this.state.mobilePhone,
      facebook: this.state.facebook,
      linkedin: this.state.linkedin,
      twitter: this.state.twitter,
      instagram: this.state.instagram,
      icon: this.state.tempIcon
    }

    if (this.props.contact) {
      contact.id = this.props.contact.id;
      this.props.updateContact(contact).then((data) => {
        this.props.onCancelClick();
      });
    }
  }

  _handleCancelClick() {
    let initialState = this.getInitialState();

    if (this.props.contact) {
      var contact = this.props.contact;
      initialState = Object.assign({}, initialState, {
        ...contact
      });
    }

    this.setState({
      ...initialState
    }, () => {
      this.props.onCancelClick();
    });

  }

  _handleChange(field, e) {
    if (field == 'company') {
      this.props.invalidateOrganizations();
      if (e.target.value) {
        this.props.fetchOrganizations(e.target.value, 0);
        this.setState({
          query: e.target.value
        })
      }
    }
    this.setState({
      [field]: e.target.value
    });
  }

  validateForm() {
    let errors = {};
    const { firstName, email } = this.state;
    if (!firstName || firstName.trim() == '') {
      errors.firstName = 'Enter a valid name';
    }

    const emailError = this._validateEmail(email);
    if (emailError) {
      errors.email = emailError;
    }

    return errors;
  }

  _validateEmail(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (!email || email.trim() == '') {
      return 'Enter a valid email';
    }

    if (!regex.test(email)) {
      return 'Enter a valid email';
    }
  }

  hasFieldError(field) {
    return this.state.errors[field];
  }

  renderDoneButtonTitle() {
    if (this.state.editing) {
      if (this.props.updating) {
        return `${this.localizedCommonsActions.saving}...`;
      } else {
        return `${this.localizedCommonsActions.save}`;
      }
    }
  }

  _handleUploadContactImage(e) {
    this.setState({
      file: e.target.files[0]
    })
  }

  onImageChange(icon) {
    this.setState({
      tempIcon: icon,
      file: null,
      errors: {}
    });
  }

  onUploadCancel() {
    this.setState({
      icon: this.state.icon,
      file: null,
      errors: {}
    });
  }

  componentDidMount() {

    if (this.props.contact) {
      let initialState = this.getInitialState();
      const result = lodash.mapValues(this.props.contact, v => _.isNil(v) ? '' : v)
      initialState = Object.assign({}, initialState, {
        ...result,
        editing: true
      });
      this.setState({
        ...initialState
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.contact, nextProps.contact)) {
      let initialState = this.getInitialState();
      if (nextProps.contact) {
        const result = lodash.mapValues(nextProps.contact, v => _.isNil(v) ? '' : v)
        initialState = Object.assign({}, initialState, {
          ...result,
          editing: true
        });
      }

      this.state = initialState;
      this.props.fetchContactList(_.get(this.props,"contactList",""));

    }

    if (!isEqual(this.props.isResetView, nextProps.isResetView)) {
      let initialState = this.getInitialState();
      this.setState({
        ...initialState
      });
    }

    if (!isEqual(this.state.organizations, nextProps.organizations)) {
      this.setState({
        organizations: nextProps.organizations
      })
    }

    if (this.props.errors != nextProps.errors) {
      var errors = this.state.errors;

      if (nextProps.errors && nextProps.errors.errors) {
        nextProps.errors.errors.forEach(error => {
          if (error.field) {
            errors[error.field] = error.message;
          } else {
            errors["email"] = error.message;
          }
        });
      }

      this.setState({
        errors: errors
      })
    }
  }

  handleSelectClick(organization) {
    this.props.invalidateOrganizations();
    this.setState({
      company: organization,
      query: ""
    })
  }

  loadMoreOrganizations() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    this.props.fetchOrganizations(this.state.query, nextPage);
  }

  enabledNewOrganization() {

    let organizationExists = _.find(this.props.organizations, (organization) => {
      return organization.name.toLowerCase() === this.state.company.toLowerCase()
    });
    if (organizationExists) {
      return false;
    }
    return true;
  }

  render() {
    return (
      <div className={cx(styles.content, this.props.className)}>
        {userRoleService.canCreateContact() &&
          <Row className={styles.body}>
            <Col sm={12} md={12} className={styles.column}>
              <div className={styles.iconContainer}>

                {!(this.state.icon || this.state.tempIcon) &&(
                  <div className={styles.addIconContainer}>
                    <i className="paperflite-add" aria-hidden="true"></i>
                    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.localizedUpdateContact.actions.add_profile_image) }}></span>
                  </div>
                )}

                {(this.state.tempIcon || this.state.icon) &&
                  <Image src={this.state.tempIcon ? this.state.tempIcon :
                    this.state.icon.thumbnail} />
                }

                <input type="file" id="uploadContactIcon" accept="image/*" onChange={this._handleUploadContactImage}></input>
              </div>
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.first_name}
                errorMessage={this.hasFieldError('firstName')}
                value={this.state.firstName}
                onChange={this._handleChange.bind(this, 'firstName')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.last_name}
                value={this.state.lastName}
                onChange={this._handleChange.bind(this, 'lastName')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.email}
                errorMessage={this.hasFieldError('email')}
                value={this.state.email}
                onChange={this._handleChange.bind(this, 'email')}
                disabled={this.state.editing}
                errorStyle={styles.errorStyle} />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.title}
                value={this.state.title}
                onChange={this._handleChange.bind(this, 'title')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.company}
                value={this.state.company}
                onChange={this._handleChange.bind(this, 'company')}
                errorStyle={styles.errorStyle} />

              {this.state.query &&
                <div className={styles.organizations}>
                  {this.enabledNewOrganization() &&
                    <div className={styles.addOrganization} onClick={() => this.handleSelectClick(this.state.company)}>
                      <i className="paperflite-add" /> {`Add ${this.state.company} as a new organization`}
                    </div>
                  }
                  <InfiniteScroll
                    pageStart={0}
                    initialLoad={false}
                    hasMore={this.props.currentPage < this.props.totalPages}
                    loadMore={this.loadMoreOrganizations}
                    useWindow={false}
                    threshold={200}
                  >
                    {this._renderOrganizations()}
                  </InfiniteScroll>
                </div>
              }
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.work_phone}
                value={this.state.workPhone}
                onChange={this._handleChange.bind(this, 'workPhone')}
                errorStyle={styles.errorStyle} />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.mobile}
                value={this.state.mobilePhone}
                onChange={this._handleChange.bind(this, 'mobilePhone')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.category}>{this.localizedUpdateContact.social_profiles}:</Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.facebook}
                value={this.state.facebook}
                onChange={this._handleChange.bind(this, 'facebook')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.linkedin}
                value={this.state.linkedin}
                onChange={this._handleChange.bind(this, 'linkedin')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.twitter}
                value={this.state.twitter}
                onChange={this._handleChange.bind(this, 'twitter')}
                errorStyle={styles.errorStyle}
              />
            </Col>

            <Col sm={12} className={styles.fields}>
              <InputField
                className={styles.inputField}
                placeholder={this.localizedUpdateContact.placeholders.instagram}
                value={this.state.instagram}
                onChange={this._handleChange.bind(this, 'instagram')}
                errorStyle={styles.errorStyle}
              />
            </Col>


          </Row>
        }
            <div className={styles.actions}>
            <Button
              onClick={() => { this._handleCreateClick() }}
              text={this.renderDoneButtonTitle()}
              variant='primary'
            />
            <Button
              onClick={() => { this._handleCancelClick() }}
              text={this.localizedCommonsActions.cancel}
              variant='secondary'
              className={styles.cancel}
          
              />
           </div>
        <ImageEditor className={styles.editor}
          show={this.state.file != null}
          image={this.state.file}
          onChange={this.onImageChange}
          onCancel={this.onUploadCancel}
          borderRadius={20}
          width={400}
          height={400}
        />
      </div>
    );
  }


  _renderOrganizations() {
    var rows = Array();

    this.props.organizations.forEach((organization, index) => {
      rows.push(
        <div className={styles.userRow} key={organization.id} onClick={() => this.handleSelectClick(organization.name)}>
          <div className={styles.name}>
            {organization.name}
          </div>
        </div>
      )
    });

    return rows
  }
}




export default ContactForm;